import React from "react";

function Welcome() {
  return (
    <div>
      <p>
        Welcome to Context Manager, a new way to manage your cell line lists.
      </p>
      <p>
        “Contexts” are a more powerful, rules-based approach to defining sets of
        cell lines of interest. It’s often faster and easier to define a rule or
        two than to select individual cell lines by hand. All of your existing
        cell line lists have been converted to contexts and appear in the list
        below.
      </p>
    </div>
  );
}

export default Welcome;
